import { PaginatedData } from "@/api/utils";
import { useEffect, useState } from "react";

export function useRowCount<T>(data?: PaginatedData<T>) {
  // remember rowCount in separate state variable to avoid resetting pagination model when data is temporarily undefined while fetching next pages
  const [rowCount, setRowCount] = useState(0);
  useEffect(() => {
    if (data?.count !== undefined) {
      setRowCount(data.count);
    }
  }, [data?.count]);
  return rowCount;
}
